@if (creditBlockModal) {
  <div>
    <div id="creditpopup" class="modal fade in" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" [ngClass]="{'show': creditBlockModal}">
      <div class="modal-dialog">
        <div class="modal-content">
          @if (creditPopUpData) {
            <div class="modal-body">
              <div class="col-xs-12 returnopenheader">
                <h4 class="modal-title return_popHeader col-xs-9 no-padding">{{creditPopUpData.headline}}</h4>
                <div class="col-xs-3 no-padding">
                  <span class="OMexit_popClose creditBlockExit_pop" data-bs-dismiss="modal"
                  (click)="closeCreditPopUp()">&times;</span>
                </div>
              </div>
              <p class="returnpopupsub col-xs-12 margin-T20">{{creditPopUpData.message1}}</p>
              <p class="returnpopupsub col-xs-12">{{creditPopUpData.message2}}</p>
              @if (popupsData.hasOverDueInvoice == false) {
                <p class="returnpopupsub  col-xs-12">{{creditPopUpData.message3}}</p>
                <div class="clearboth"></div>
                <div class="OM_exitPopBtnParent">
                  <button class="returnbtn allinvoiceredirect creditBlockExit_pop"
                  [innerHTML]="creditPopUpData.content"></button>
                </div>
              } @else {
                <p class="returnpopupsub  col-xs-12 margin-B20">{{creditPopUpData.message3}}</p>
                <div class="clearboth"></div>
              }
              <div class="clearboth"></div>
              <div class="returnpopupjobcode">
                {{creditPopUpData.jobBagCode}}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
<!--old uk consent-->
<!-- <div *ngIf="showConsentPopup && !isAsmUser">
<div id="consentpopup" class="modal fade in" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false"
  [ngClass]="{'show': showConsentPopup && !isAsmUser}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <h4 class="modal-title consentheader col-xs-9">{{ukConsentPopupData.headline}}</h4>
        <p class="consentsubheader col-xs-12"><span>{{ukConsentPopupData.message1}}</span>
        <span class="consentsubheader_mail">{{marketingEmail}}</span>
        <span>{{ukConsentPopupData.message2}} </span>
        <span>
          <a target="_blank" href={{ukConsentPopupData.button}}>privacy policy</a>.
        </span>
      </p>
      <p class="consentsubheader col-xs-12">{{ukConsentPopupData.message3}}</p>
      <div class="clearboth"></div>
      <div class="consentpopbtnparent">
        <button class="consentyesbtn"
        (click)="isConsentGranted('true')">{{ukConsentPopupData.content}}</button>
        <button class="consentNobtn" data-bs-dismiss="modal"
        (click)="isConsentGranted('false')">{{ukConsentPopupData.label1}}</button>
      </div>
      <div class="consentPopupDocUk">{{ukConsentPopupData.jobBagCode}}<div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div> -->

<!--new consent popup -->
@if (showConsentPopup && !isAsmUser) {
  <div class="Uk_Consent_Popup">
    <div id="consentpopup" class="modal fade " role="dialog" data-bs-backdrop="static" data-bs-keyboard="false"
      [ngClass]="{'show': showConsentPopup && !isAsmUser}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="pop_Txt_Container">
              <div class="pop_Modal_Body">
                <div class="modal_title consentheader uk_Consent_Header" [innerHTML]="ukConsentPopupData?.headline"></div>
                <div class="uk_Consent_List">
                  <div class="uk_Consent_Li_Item">
                    <img class="uk_Consent_Icons" src="../../../assets/images/idea.svg">
                    <div class="uk_Consent_Li_Txt" [innerHTML]="ukConsentPopupData?.message1"></div>
                  </div>
                  <div class="uk_Consent_Li_Item">
                    <img class="uk_Consent_Icons" src="../../../assets/images/calendar.svg">
                    <div class="uk_Consent_Li_Txt" [innerHTML]="ukConsentPopupData?.message2"></div>
                  </div>
                  <div class="uk_Consent_Li_Item">
                    <img class="uk_Consent_Icons" src="../../../assets/images/notificationicon.svg">
                    <div class="uk_Consent_Li_Txt" [innerHTML]="ukConsentPopupData?.message3"></div>
                  </div>
                </div>
              </div>
              <div class="popup_Modal_Footer">
                <button class="continue_Btn" (click)="isConsentGranted('true')" [innerHTML]="ukConsentPopupData?.link"></button>
                <button class="cancel_Btn" (click)="isConsentGranted('false')" [innerHTML]="ukConsentPopupData?.button" data-bs-dismiss="modal"></button>
              </div>
            </div>
            <div class="pop_Img_Container">
              <div class="pop_Bg_Img" [ngStyle]="{'background-image': 'url(' + getImage(ukConsentPopupData?.media) + ')'}">
              </div>
              <div class="pop_Txt">
                <span [innerHTML]="ukConsentPopupData?.label1"></span>
                <span>{{marketingEmail}}</span>
                <span [innerHTML]="ukConsentPopupData?.content"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- US marketing consent popup starts ( marketing opts changes ) -->
@if (showUSConsentPopup && !isAsmUser) {
  <div>
    <div id="consentpopupUS" class="modal fade in marketing-consent" role="dialog" data-bs-backdrop="static"
      data-bs-keyboard="false" [ngClass]="{'show': showUSConsentPopup && !isAsmUser}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4 class="modal-title consentheader col-xs-10">{{usConsentPopupData.headline}}</h4>
            <div class="no-padding pull-right">
              <span class="consentClose" data-bs-dismiss="modal"
              (click)="isConsentGranted('false')">&times; </span>
            </div>
            <div class="clearboth"></div>
            <p class="consentsubheader col-xs-12">
              {{usConsentPopupData.message1}}
            </p>
            <p class="consentsubheader col-xs-12" [innerHTML]="usConsentPopupData.message2">
            </p>
            <div class="clearboth"></div>
            <div class="consentpopbtnparent">
              <button class="consentyesbtn" (click)="isConsentGranted('true')">
                {{usConsentPopupData.message3}}
              </button>
              <button class="consentNobtn" data-bs-dismiss="modal"
                (click)="isConsentGranted('false')">
                {{usConsentPopupData.content}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!-- marketing consent popup ends -->

@if (showApiFailurePopup) {
  <div>
    <div id="apifailurepopup" class="modal fade in" role="dialog" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" [ngClass]="{'show': showApiFailurePopup}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-xs-12 returnopenheader">
              <h4 class="modal-title return_popHeader col-xs-9 no-padding">
              {{apiFailurePopupData.headline}}</h4>
              <div class="col-xs-3 no-padding">
                <!-- <span class="OMexit_popClose" data-dismiss="modal">&times;</span>  -->
              </div>
            </div>
            <p class="returnpopupsub col-xs-12 margin-T20">
              {{apiFailurePopupData.message1}}<br>{{apiFailurePopupData.message2}}</p>
              <div class="clearboth"></div>
              <div class="OM_exitPopBtnParent">
                <button class="returnbtn"><a class="exitSkipBtn"
                (click)="closeApifailurePopup()">{{apiFailurePopupData.label1}}</a></button>
              </div>
              <div class="clearboth"></div>
              <div class="returnpopupjobcode">{{apiFailurePopupData.jobBagCode}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }


  @if (!customerRegion) {
    <div>
      <div id="customerRegionpopup" class="modal fade in" role="dialog" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="col-xs-12 returnopenheader">
                <h4 class="modal-title return_popHeader col-xs-9 no-padding">
               You are on wrong website</h4>
                <div class="col-xs-3 no-padding">
                  <!-- <span class="OMexit_popClose" data-dismiss="modal">&times;</span>  -->
                </div>
              </div>
              <p class="returnpopupsub col-xs-12 margin-T20">
                you seems to be on wrong website, Please visit https://www.flu360.uk.com</p>
                <div class="clearboth"></div>
                <div class="OM_exitPopBtnParent">
                    </div>
                <div class="clearboth"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

  @if ((showReturnsFirstPopup && !isAsmUser)|| (isAsmUser && isSearchByProfile && showReturnsFirstPopup)) {
    <div>
      <div id="returnpopupactive" class="modal fade in" role="dialog" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1"
        [ngClass]="{'show': (showReturnsFirstPopup && !isAsmUser) || (isAsmUser && isSearchByProfile && showReturnsFirstPopup)}">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="col-xs-12 returnopenheader">
                <h4 class="modal-title return_popHeader col-xs-9 no-padding">
                {{returnsFirstPopupData.headline}}</h4>
                <div class="col-xs-3 no-padding">
                  <span class="OMexit_popClose returnsExit_pop" (click)="closeReturnsFirstPopup()"
                  data-bs-dismiss="modal">&times;</span>
                </div>
              </div>
              <p class="returnpopupsub col-xs-12 margin-T20">{{returnsFirstPopupData.message1}}</p>
              <p class="returnpopupsub col-xs-12" [innerHTML]="returnsFirstPopupData.message2"></p>
              <div class="clearboth"></div>
              <div class="OM_exitPopBtnParent">
                <button class="ReturnDont" data-bs-dismiss="modal"
                (click)="sendNotShowFirstPopup()">{{returnsFirstPopupData.message3}}</button>
                <button class="returnbtn returnsExit_pop" (click)="closeReturnsFirstPopup()"><a
                routerLink="/returns">{{returnsFirstPopupData.label1}}</a></button>
              </div>
              <div class="clearboth"></div>
              <div class="returnpopupjobcode">
                {{returnsFirstPopupData.jobBagCode}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if ((showReturnsSecPopup && !isAsmUser)|| (isAsmUser && isSearchByProfile && showReturnsSecPopup)) {
    <div>
      <div id="returnpopup" class="modal fade in" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false"
        tabindex="-1"
        [ngClass]="{'show': (showReturnsSecPopup && !isAsmUser) || (isAsmUser && isSearchByProfile && showReturnsSecPopup)}">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="col-xs-12 returnopenheader">
                <h4 class="modal-title return_popHeader col-xs-9 no-padding">
                {{returnsSecPopupData.headline}}</h4>
                <div class="col-xs-3 no-padding">
                  <span class="OMexit_popClose returnsExit_pop" (click)="closeReturnsSecPopup()"
                  data-bs-dismiss="modal">&times;</span>
                </div>
              </div>
              <p class="returnpopupsub col-xs-12 margin-T20">{{returnsSecPopupData.message1}}</p>
              <p class="returnpopupsub col-xs-12" [innerHTML]="returnsSecPopupData.message2"></p>
              <div class="clearboth"></div>
              <div class="OM_exitPopBtnParent">
                <button class="ReturnDont" data-bs-dismiss="modal"
                (click)="sendNotShowSecPopup()">{{returnsSecPopupData.message3}}</button>
                <button class="returnbtn returnsExit_pop" (click)="closeReturnsSecPopup()"><a
                routerLink="/returns">{{returnsSecPopupData.label1}}</a></button>
              </div>
              <div class="clearboth"></div>
              <div class="returnpopupjobcode">
                {{returnsSecPopupData.jobBagCode}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <!--pop up for auto rollover-->

  @if (ArrPopUpModal) {
    <div>
      <div id="autoRollOverPopUP" class="modal" tabindex="-1" role="dialog" data-bs-backdrop="static"
        [ngClass]="{'show': ArrPopUpModal}">
        <div class="modal-dialog">
          <div class="modal-content">
            @if (autoRolloverPopUpData) {
              <div class="modal-body">
                <div class="autoRollOverHeader">
                  <img src="assets/images/Frame.svg" class="autoRolloverIcon">
                  <div class="close_Btn" data-bs-dismiss="modal" aria-label="Close"
                  (click)="closeAutoRolloverPopUp('close')">&times;</div>
                </div>
                <p class="autoRolloverHeading  margin-T20">{{autoRolloverPopUpData.headline}}</p>
                <p class="autoRolloverSubText">{{autoRolloverPopUpData.message1}}</p>
                <div class="clearboth"></div>
                <div class="autoRolloverBtnParent">
                  <button class="autoRollOver_SignUp" data-bs-dismiss="modal"
                    [routerLink]="autoRolloverPopUpData.link"
                  (click)="signUpForAutoRollover()">{{autoRolloverPopUpData.message2}}</button>
                  <button class="autoRollOver_Notnow" data-bs-dismiss="modal"
                  (click)="closeAutoRolloverPopUp('not_now')">{{autoRolloverPopUpData.message3}}</button>
                </div>
                <div class="clearboth"></div>
                <div class="terms-checkbox">
                  <label>
                    <input type="checkbox" class="rollover_Checkbox" [(ngModel)]="termsAccepted" />
                    <span class="checkbox-button__control"></span>
                  </label>
                  <div [innerHTML]="autoRolloverPopUpData.content" class="notNowText"></div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }